import React from 'react';

import Layout from './layout';
import Intro from './intro';

const App = props => props.settings.weight ? <Layout {...props} /> : <Intro {...props} />;

export default App;



// WEBPACK FOOTER //
// ./src/components/app.js